import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import Tabs from '../screens/tabs/Tabs'
import CustomerTabs from '../screens/tabs/CustomerTabs'

import { getIsSuitesMode } from '../selectors/config'

import { menusAndItemsRequested } from '../actions/menus'
import { getActiveAttendantId, getAttendants } from '../selectors/attendant'
import { isEmpty } from 'lodash'

const TabsModeResolver = ({ isSuites, hasActiveAttendant, attendantsExist, redirectToLogin, fetchMenusAndItems, ...props }) => {
  useEffect(() => {
    if (attendantsExist && !hasActiveAttendant) {
      redirectToLogin()
    }
  }, [hasActiveAttendant])

  useEffect(() => {
    if (localStorage.getItem('accessToken')) fetchMenusAndItems()
  }, [fetchMenusAndItems])

  return isSuites ? <CustomerTabs {...props} /> : <Tabs {...props} />
}

const mapStateToProps = (state) => {
  const isSuites = getIsSuitesMode(state)
  const attendantsExist = !isEmpty(getAttendants(state))
  const hasActiveAttendant = getActiveAttendantId(state) !== undefined

  return { isSuites, hasActiveAttendant, attendantsExist }
}

const mapDispatchToProps = (dispatch, props) => {
  const replace = props?.history?.replace ?? function(){}

  return {
    fetchMenusAndItems: () => {
      dispatch(menusAndItemsRequested())
    },
    redirectToLogin: () => {
      replace('/user-login')
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TabsModeResolver))
